import type { EcoCostsReducerType } from "../../utils/ecoCostsUtils";
import type { EcoCostsActionsType } from "../actions/EcoCostsActions";
import { ECO_COSTS_SET_DATA, ECO_COSTS_SET_FAILED, ECO_COSTS_SET_ERRORS } from "../actions/EcoCostsActions";

export const initialState: EcoCostsReducerType = {
    initialized: false,
    failed: false,
    data: null,
    payload: null,
    errors: [],
};

const ecoCostsReducer = (
    state: EcoCostsReducerType = initialState,
    action: EcoCostsActionsType,
): EcoCostsReducerType => {
    switch (action.type) {
        case ECO_COSTS_SET_FAILED:
            return { ...state, failed: action.failed, payload: action.payload };

        case ECO_COSTS_SET_DATA:
            return { ...state, initialized: true, data: action.ecoCosts, payload: action.payload };

        case ECO_COSTS_SET_ERRORS:
            return { ...state, errors: action.errors };

        default:
            return state;
    }
};

export default ecoCostsReducer;
